/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy } from './get-zeus-organization-identity-verifications-for-president200-response-inner-status-history-changed-by';

/**
 * 
 * @export
 * @interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
 */
export interface GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
     */
    'changedAt': string;
    /**
     * 
     * @type {GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
     */
    'changedBy': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryChangedBy;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistory
     */
    'status': GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum;
}

export const GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum = {
    approved: 'APPROVED',
    rejected: 'REJECTED'
} as const;

export type GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum = typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum[keyof typeof GetZeusOrganizationIdentityVerificationsForPresident200ResponseInnerStatusHistoryStatusEnum];


